









































































import { computed, defineComponent, ref } from '@vue/composition-api';
import AddStratificationDialog from '@/components/dialog/AddStratificationDialog.vue';
import { useAllResources } from '@/store/modules/resources';
import FieldsViewExportCsv from './FieldsViewExportCsv.vue';
import FieldsViewGroupFilter from './FieldsViewGroupFilter.vue';
import FieldsViewRecentActivityFilter from './FieldsViewRecentActivityFilter.vue';
import FieldsViewSearchInput from './FieldsViewSearchInput.vue';
import FieldsViewStatusFilter from './FieldsViewStatusFilter.vue';

export default defineComponent({
	components: {
		FieldsViewSearchInput,
		FieldsViewGroupFilter,
		FieldsViewRecentActivityFilter,
		FieldsViewStatusFilter,
		FieldsViewExportCsv,
		AddStratificationDialog,
	},
	setup(_, { root }) {
		const showGroupFilter = ref(false);
		const showRecentActivityFilter = ref(false);
		const showStatusFilter = ref(false);
		const showExportCSV = ref(false);
		const numberOfResults = computed(() => root.$store.getters['fieldsView/getFieldRowsLength']);
		const { isLoaded } = useAllResources(root.$store);

		return {
			showGroupFilter,
			showRecentActivityFilter,
			showStatusFilter,
			showExportCSV,
			numberOfResults,
			isLoaded,
			clearAllFilters: () => {
				root.$store.dispatch('fieldsView/clearAllFilters');
			},
		};
	},
});
